// Preact
// eslint-disable-next-line no-unused-vars
import { Fragment, h } from 'preact';
import { useContext } from 'preact/hooks';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { SearchContext } from '../contexts/Search';

/**
 * The main component.
 *
 * @param {Object} props Props
 * @return {Object} JSX
 */
const Skeleton = ( props ) => {
	const { children, className, lines, ...rest } = props;
	const { state } = useContext( SearchContext );
	const { loading } = state;

	return (
		<div className={classNames( 'faceted-search__skeleton', { 'faceted-search__skeleton--is-loading': loading }, className ) } {...rest} style={`--skeleton-lines: ${lines}`}>
			{children}
		</div>
	);
};

Skeleton.defaultProps = {
	className: '',
	lines: 1
};

Skeleton.propTypes = {
	children: PropTypes.oneOfType( [
		PropTypes.arrayOf( PropTypes.node ),
		PropTypes.node
	] ).isRequired,
	className: PropTypes.string,
	lines: PropTypes.number,
};

export default Skeleton;
